import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  constructor(protected http: HttpClient) {
  }

  public post(url: string, data?: any): Observable<any> {
    return this.http.post(url, data);
  }

  public get(url: string) {
  }

  public delete(url: string) {
    return this.http.delete(url);
  }

  public put(url: string, data?: any) {
    return this.http.put(url, data);
  }
}
